export let BASE_URL = '/sfaas-onsite-fe';
